import useFormattedCurrency from './useFormattedCurrency';

export default {
  useFormattedCurrency,
};
